import React, { useCallback, useEffect, useState } from 'react';
import { raiseClaimService } from '../../services';
import ClaimDocumentTabCmp from './ClaimDocumentTabCmp';
import { surveyorTypeObj } from '../../constants';

const ClaimDocuments = ({ claimId, fetchClaimTemplateDetails, detailedClaim }) => {

    const { surveyorAppointmentStatus } = detailedClaim;

    const isSTPPolicy = () => {
        return detailedClaim?.policyName?.toLowerCase().includes('stp');
    }


    const isEstimatedLossNotMore25000 = () => {
        return !(detailedClaim?.estimatedLoss > 25000);
    }

    const isClaimMarine = () => {
        return detailedClaim?.storageTransitType?.toLowerCase() === 'transit'
    }

    const isSelfSurveyor = () => {
        const isMisc = detailedClaim?.policyType?.toLowerCase().includes('misc') || detailedClaim?.policyType?.toLowerCase().includes('miscellaneous');
        const isMiscPolicy = isMisc && detailedClaim?.policyName?.toLowerCase().includes('PEEI'.toLocaleLowerCase()) || detailedClaim?.policyName?.toLowerCase().includes('EEI'.toLocaleLowerCase()) || detailedClaim?.policyName?.toLowerCase().includes('GPA'.toLowerCase())
        const isGroupMedical = detailedClaim?.policyType?.toLowerCase().includes('Group Medical'.toLowerCase())

        return (isSTPPolicy() && isEstimatedLossNotMore25000() && isClaimMarine()) || (isMisc && isMiscPolicy) || isGroupMedical
    }

    const [claimDocumentDetail, setClaimDocumentDetail] = useState([]);
    const [loading, setLoading] = useState(false);

    const claimDocumentTabList = [
        {
            id: 1,
            title: "Claim documents during intimation",
            key: "CLAIM_DOC_LIST_DURING_RAISE",
            status: claimDocumentDetail?.claimTabStatus?.claimDocumentSubmissionDate ? 'COMPLETED' : 'PENDING',
            show: true
        },
        {
            id: 2,
            title: "JIR Documents",
            key: "JIR_DOCUMENTS",
            status: claimDocumentDetail?.claimTabStatus?.jirDate ? 'COMPLETED' : 'PENDING',
            show: surveyorAppointmentStatus !== surveyorTypeObj['SELF_SURVEYOR']
        },
        {
            id: 3,
            title: "LOR Documents",
            key: "LOR_DOCUMENTS",
            status: claimDocumentDetail?.claimTabStatus?.isAllLorSubmitted ? 'COMPLETED' : isSelfSurveyor() ? 'PENDING' : claimDocumentDetail?.claimTabStatus?.jirDate ? 'PENDING' : 'NOT_STARTED',
            show: true
        },
        {
            id: 4,
            title: "FSR Documents",
            key: "FSR_DOCUMENTS",
            status: claimDocumentDetail?.claimTabStatus?.fsrDate ? 'COMPLETED' : claimDocumentDetail?.claimTabStatus?.isAllLorSubmitted ? 'PENDING' : 'NOT_STARTED',
            show: true
        },
        // {
        //     id: 5,
        //     title: "FSR Documents",
        //     key: "FSR_DOCUMENTS_SELF_SURVEYOR",
        //     status: 'COMPLETED',
        //     show: isSTPPolicy() ? false : surveyorAppointmentStatus === surveyorTypeObj['SELF_SURVEYOR']
        // }
    ]

    //this is for overview tab 
    // Set "raise-claimdoc" as the default active tab
    const [activeTab, setActiveTab] = useState("CLAIM_DOC_LIST_DURING_RAISE");
    const [activeTabTitle, setActiveTabTitle] = useState("Claim Document During Raise");

    const handleTabClick = async (tab) => {
        setActiveTab(tab.key);
        setActiveTabTitle(tab.title);
    };

    const fetchClaimDocument = useCallback(async () => {
        let type = ''
        switch (activeTab) {
            case "CLAIM_DOC_LIST_DURING_RAISE":
                type = 'raise_claim_document'
                break;
            case "JIR_DOCUMENTS":
                type = 'jir'
                break;
            case "LOR_DOCUMENTS":
                type = 'lor'
                break;
            case "FSR_DOCUMENTS":
                type = 'fsr'
                break;
            default:
                type = 'raise_claim_document'
                break;
        }
        setLoading(true)
        if (type === 'fsr') {
            let claimDetails = [];
            let otherDocument = [];
            let PrDcDocument = [];
            const fsrClaimDocRes = await raiseClaimService.getClaimDocumentDetails({
                claimId: claimId,
                fileType: 'fsr'
            });
            if (fsrClaimDocRes?.isSuccess) {
                claimDetails = fsrClaimDocRes?.data
            }
            else {
                claimDetails = [];
            }
            const fsrOtherClaimDocRes = await raiseClaimService.getClaimDocumentDetails({
                claimId: claimId,
                fileType: 'other_document'
            });
            if (fsrOtherClaimDocRes?.isSuccess) {
                otherDocument = fsrOtherClaimDocRes?.data
            }
            else {
                otherDocument = [];
            }
            const fsrPrDcClaimDocRes = await raiseClaimService.getClaimDocumentDetails({
                claimId: claimId,
                fileType: 'destruction_certificate'
            });
            if (fsrPrDcClaimDocRes?.isSuccess) {
                PrDcDocument = fsrPrDcClaimDocRes?.data
            }
            else {
                PrDcDocument = [];
            }
            setClaimDocumentDetail({ claimDetails: claimDetails, otherDocument: otherDocument, PrDcDocument: PrDcDocument, lorCount: fsrClaimDocRes?.lorCount, claimTabStatus: fsrClaimDocRes?.claimTabStatus })
        }
        else {
            const claimDocRes = await raiseClaimService.getClaimDocumentDetails({
                claimId: claimId,
                fileType: type
            });
            if (claimDocRes?.isSuccess) {
                setClaimDocumentDetail({ claimDetails: claimDocRes?.data, lorCount: claimDocRes?.lorCount, claimTabStatus: claimDocRes?.claimTabStatus })
            }
            else {
                setClaimDocumentDetail({ claimDetails: [], lorCount: 0 })
            }
        }
        setLoading(false)
    }, [activeTab, claimId]);

    useEffect(() => {
        window.scroll(0, 0)
        const fetchList = async () => {
            await fetchClaimDocument()
        }
        fetchList()
    }, [fetchClaimDocument])

    return (
        <>
            {/* this is adding for testing purpose */}
            <div className="claim_overview_inrtab">

                {/* when button is disabled then apply (button_adding_disable) class i apply only 2 button and one is norml mode */}

                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {
                        claimDocumentTabList.map((tab) => (
                            tab.show ? <li className="nav-item" key={tab.key}>
                                <button
                                    className={`nav-link ${tab.status === 'NOT_STARTED' ? "button_adding_disable" : ""} ${activeTab === tab.key ? "active" : ""}`}
                                    id="raise-claimdoc-tab"
                                    onClick={() => handleTabClick(tab)}
                                    role="tab"
                                    aria-controls={tab.key}
                                    aria-selected={activeTab === tab.key}
                                    disabled={tab.status === 'NOT_STARTED' ? true : false}
                                >
                                    {tab.title}   <span className={tab.status === 'COMPLETED' ? 'tab_succes' : 'tab_faild'}></span>
                                </button>
                            </li> : null
                        ))
                    }
                </ul>

                {claimDocumentDetail && <ClaimDocumentTabCmp tabLoading={loading} activeTab={activeTab} title={activeTabTitle} documentDetails={claimDocumentDetail} fetchClaimDocument={fetchClaimDocument} claimId={claimId} fetchClaimTemplateDetails={fetchClaimTemplateDetails} detailedClaim={detailedClaim} />}
            </div>
        </>
    );
};




export default ClaimDocuments;